<script setup>
import {computed, onMounted, ref, watch} from "vue";
import PageTitle from "@/components/common/PageTitle.vue";
import NavCard from "@/components/common/NavCard.vue";
import { useI18n } from 'vue-i18n';
import { useRoute } from "vue-router";
import {getAvailableActionsForRoute} from "@/services/api/permissionManagement.js";
import BasePage from "@/components/Layouts/BasePage.vue";

const { t } = useI18n();
const route = useRoute();
const actionsManufacturer = ref(null);
const actionsAttribute = ref(null);
const actionsLayout = ref(null);
const actionsPOP = ref(null);
const actionsPool = ref(null);
const actionsConcentrator = ref(null);
const isLoaded = ref(false);
const havePermissions = ref(false);

const breadcrumbs = computed(() => {
    const items = [
        { label: t("components.settings.permissionManagement.menuList.ISP"), to: "/isp" }
    ];
    return items;
});

const cards = computed(() => {
    const baseCards = [];
    if (actionsLayout.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.AttributesLayout",
            subtitle:"components.isp.index.layoutDescription",
            icon: "public",
            routeName: "isp/layouts",
        });
    }
    if (actionsManufacturer.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.Manufacturer",
            subtitle:"components.isp.index.manufacturerDescription",
            icon: "factory",
            routeName: "isp/manufacturer",
        });
    }
    if (actionsAttribute.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.Attribute",
            subtitle:"components.isp.index.attributeDescription",
            icon: "description",
            routeName: "isp/attribute",
        });
    }

    if (actionsPOP.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.POP",
            subtitle:"components.isp.index.popDescription",
            icon: "description",
            routeName: "isp/pops",
        });
    }

    if (actionsPool.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.Pool",
            subtitle:"components.isp.index.poolDescription",
            icon: "description",
            routeName: "isp/pools",
        });
    }

    if (actionsConcentrator.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.Nas",
            subtitle:"components.isp.index.concentratorDescription",
            icon: "description",
            routeName: "isp/concentrators",
        });
    }
    return baseCards;

});

watch(cards, (newCards) => {
    havePermissions.value = newCards.length > 0;
});

onMounted(async  () => {
    try {
        actionsManufacturer.value = await getAvailableActionsForRoute("Resources/ISP/Manufacturer");
        actionsAttribute.value = await getAvailableActionsForRoute("Resources/ISP/Attribute");
        actionsLayout.value = await getAvailableActionsForRoute("Resources/ISP/Layout");
        actionsPOP.value = await getAvailableActionsForRoute("Resources/ISP/POP");
        actionsPool.value = await getAvailableActionsForRoute("Resources/ISP/Pool");
        actionsConcentrator.value = await getAvailableActionsForRoute("Resources/ISP/Pool");
    } catch (err) {
        console.error("Error Permissions: ", err);
    } finally {
        isLoaded.value = true;
    }
})

</script>
<template>
    <div v-if="isLoaded && havePermissions && $route.name === 'isp' ">
        <PageTitle :breadcrumbs="breadcrumbs" />
        <v-card class="bg-white trezo-card  base-page-height">
            <NavCard :cards="cards" />
        </v-card>
        <router-view />
    </div>

    <div v-else-if="isLoaded && !havePermissions">
        <v-alert class="text-danger">
            {{ t("common.messages.errors.403") }}
        </v-alert>
    </div>
</template>

